export const userIconColorValues: Record<string, string> = {
  pink: "#cf3e73",
  orange: "#E06C75", // previously: "#FA5B19"
  beige: "#e5a47b", // previously: "#FAD992"
  yellow: "#e2db7d", // previously: "#F5F20A"
  green: "#98C379", // previously: "#0FDC00"
  lightblue: "#56B6C2", // previously: "#0CDAF5"
  darkblue: "#61AFEF", // previously: "#7096D4"
  purple: "#C678DD", // previously: "#A413FA"
};


export function getUserInitials(name: string): string {
  const parts = name.trim().split(" ");
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

export function getUserImageSrc(profilePicture?: string | null): string | undefined {
  return profilePicture ? `/api/files/${profilePicture}/image.jpg` : undefined;
}
